<h2 mat-dialog-title>Exportar CSV de Entrega</h2>
<mat-dialog-content>
  <div class="dialog-content">
    <p>Selecione a entrega para exportar:</p>
    <mat-form-field appearance="fill">
      <mat-label>Entrega</mat-label>
      <mat-select [(ngModel)]="selectedChildOrder">
        @for (child of data.childOrders; track child) {
          <mat-option [value]="child.id">
            Entrega {{child.entregaNumber}} - {{child.dataEntrega | date:'MM/yyyy'}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancelar</button>
  <button mat-button color="primary" [disabled]="!selectedChildOrder" (click)="onConfirm()">
    Exportar
  </button>
</mat-dialog-actions>